<template>
  <div class="project-detail">
    <router-view />
  </div>
</template>

<script>
import { checkGuide } from '@/constants/guide'
import createProjectDetailSteps from '@/constants/guide-steps-project-detail'

export default {
  name: 'ProjectDetail',
  
  computed: {
    projectId() {
      return this.$route.params.projectId
    },
    userInfo() {
      return this.$store.getters.userInfo || {}
    }
  },

  mounted() {
    setTimeout(() => {
      var steps = createProjectDetailSteps(this.projectId)
      checkGuide(this.userInfo, 'projectDetail', steps, (guideKey, version) => {
        var token = localStorage.getItem('ACCESS_TOKEN') || ''
        var baseUrl = process.env.VUE_APP_BASE_URL || ''
        fetch(baseUrl + '/jkd/home/user/markGuide', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
          body: JSON.stringify({ guideKey: guideKey, guideVersion: version })
        }).catch(function () {})
      }, this.$router)
    }, 1000)
  }
}
</script>

<style lang="scss" scoped>
.project-detail {
  height: 100%;
}
</style>
